<div>
  <div class="nav-container-1">
    <div class="row">
      <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 tab-container">
        <mat-tab-group (selectedTabChange)="viewTabClick($event)" animationDuration="0ms"
          [(selectedIndex)]="selectedTabIndex">
          <mat-tab label="Document Control Index" id="lblDCIReport"></mat-tab>
          <mat-tab label="DCI Revise" id="lblDCIReviseSummary"></mat-tab>
          <mat-tab label="DCI in ISO format" id="lblDCIISO"></mat-tab>
        </mat-tab-group>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3  icons-container" *ngIf="this.selectedTabIndex==2">
        <div class="d-flex justify-content-end">
            <div class="d-none d-md-block">
              <mat-label style="font-size: 16px;padding-right: 5px;">Predictive Report</mat-label>
              <mat-slide-toggle color="primary" (change)="onChange($event)">
              </mat-slide-toggle>
            </div>
        </div>
      </div>
    </div>   
  </div>

  <div>
    <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
      [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
    </ssrs-reportviewer>
  </div>
</div>